import capitalize from '../../lib/capitalize'

export const values = ['Yes', 'No']

export function autocomplete() {
	return values
}

export function predict(string) {
	const words = string.trim().toLowerCase().split(' ')
	const index = values.indexOf(capitalize(words[0]))

	if (index > -1) {
		return [words[0] === 'yes' ? values[1] : values[0]]
	}

	return []
}



// WEBPACK FOOTER //
// ./src/services/prediction/bool.js